module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-restaurant.fb651b06.jpg";